// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xsQd","right":"styles_right__18xY5"};